module.exports = __webpack_public_path__ + "img/gc_country_flag_se.2d09c9a9.svg";